import { render, staticRenderFns } from "./EmployeeSkillsEditor.vue?vue&type=template&id=b2625f7e"
import script from "./EmployeeSkillsEditor.vue?vue&type=script&lang=js"
export * from "./EmployeeSkillsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports